/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/CalendarIntegrations/Enums/CalendarProvider.php */
export const calendarProvider = {
	google: 'google',
	microsoft_365: 'microsoft_365',
} as const

/** @see backend/nexus/modules/CalendarIntegrations/Enums/CalendarProvider.php */
export type CalendarProvider = (typeof calendarProvider)[keyof typeof calendarProvider]
